export default __webpack_public_path__ + "static/proxima-nova-300-i-428f841678783f6388a475f12b1ae425.woff2";